/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Rating from "@mui/material/Rating";
import {
  Header,
  Footer,
  Loading,
  Snackbar,
  ShareButton,
} from "../../components/index";
import { WebApi } from "../../api/web";
import { IoDownload } from "react-icons/io5";
import { FiHeart } from "react-icons/fi";
import { UploadsUrl } from "../../services/url";
import { Errors } from "../../utilities/error";
const Book = () => {
  const router = useHistory();
  const { id } = useParams();
  const [bookData, setBookData] = useState(null);
  const [like, setLike] = useState(false);
  const [loading, setLoading] = useState(false);
  const [valueRate, setValueRate] = useState(null);
  useEffect(() => {
    Book();
  }, [like]);

  const LikeDisLike = async () => {
    setLoading(true);
    await WebApi.likeDislikeLibrary(id)
      .then((res) => {
        setLoading(false);
        setLike(!like);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const Book = async () => {
    setLoading(true);
    await WebApi.book(id)
      .then((res) => {
        setLoading(false);
        setBookData(res.data.data.library);
        if (res.data.data.library.rate < 6 && res.data.data.library.rate > -1) {
          setValueRate(res.data.data.library.rate);
        } else {
          setValueRate(0);
        }
      })
      .catch((err) => {
        setLoading(false);
        router.goBack();
      });
  };
  useEffect(() => {
    if (valueRate) {
      RateBook();
    }
  }, [valueRate]);

  const RateBook = async () => {
    await WebApi.rateLibrary(id, valueRate)
      .then((res) => {
        console.log("nnn", res.data);
      })
      .catch((err) => {
        Snackbar({
          title: "نا موفق",
          message: Errors[err.response.data.errors[0].message],
          type: "danger",
        });
      });
  };

  return (
    <>
      <Header title='مطالعه کتاب یا مقالعه' />
      {loading && <Loading />}
      {bookData ? (
        <div className='container'>
          <div className='template-pages'>
            <div className='top-section-single book-part'>
              <div className='click-top-section' onClick={() => LikeDisLike()}>
                {bookData.wasLike ? (
                  <FiHeart size={25} fill={"#d81818"} color={"#d81818"} />
                ) : (
                  <FiHeart size={25} />
                )}
                {bookData.countLike > 0 && (
                  <div className='count-Likes'>{bookData.countLike}</div>
                )}
              </div>
              <div className='book'>
                <img
                  className='box-shadow'
                  src={`${UploadsUrl}/${bookData.image}`}
                  alt='user'
                />
              </div>
              <ShareButton url={window.location.href} />
            </div>
            <div className='rate-book'>
              <Rating
                name='simple-controlled'
                value={valueRate}
                onChange={(event, newValue) => {
                  setValueRate(newValue);
                }}
                size='large'
              />
            </div>
            <div className='detail-book'>
              <h3>{bookData.title}</h3>
              <div className='nav-detail-book'>
                <div>
                  <span>دسته بندی : </span>
                  <span>{bookData.category.title}</span>
                </div>
                <div className='p-y-10'>/</div>
                <div>
                  <span> نویسنده : </span>
                  <span>{bookData.author}</span>
                </div>
              </div>
            </div>
            <div className='layer-shadow'></div>
            <div className='content-book'>
              <h3>{bookData.titleContent}</h3>
              <p>{bookData.content}</p>
              <a
                href={`${UploadsUrl}/${bookData.file.filename}`}
                download
                className='btn-download-pdf'
                target='_blank'
              >
                <div className='title'>
                  <span>
                    <IoDownload size={25} />
                  </span>
                  <span>دریافت فایل کتاب</span>
                </div>
                <div>PDF/{bookData.file.size}</div>
              </a>
            </div>
          </div>
        </div>
      ) : (
        <Loading />
      )}

      <Footer />
    </>
  );
};
export default Book;
